import type { Interpolation, Theme } from '@emotion/react'
import { SyntheticEvent, memo } from 'react'
import Info from '../Icons/Info'
import IconButton from './IconButton'

interface IButtonInfo {
    onClick(event: SyntheticEvent): void
    color?: string
    size?: 'small' | 'medium' | 'large'
    fontSize?: 'small' | 'medium' | 'large' | 'inherit'
    showLabel?: boolean
    overrides?: Interpolation<Theme>
    title?: string
}

const ButtonInfo = (props: IButtonInfo) => {
    const { onClick, color, fontSize, showLabel, overrides, title } = props

    const label = showLabel && title?.length > 0 ? <span>{title}</span> : null

    return (
        <IconButton
            css={overrides}
            showLabel={showLabel}
            title={title}
            onClick={onClick}
        >
            <Info color={color} fontSize={fontSize} />
            {label}
        </IconButton>
    )
}

export default memo(ButtonInfo)
